import React from 'react';

export default function Contact() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <h1 className="text-2xl font-semibold mb-4">Contact Us</h1>
      <p className="text-gray-700 mb-6">We'd love to hear from you! Please fill out the form below to get in touch.</p>
      <form>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700" htmlFor="name">Name</label>
          <input className="mt-1 block w-full border border-gray-300 rounded-md p-2" type="text" id="name" required />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700" htmlFor="email">Email</label>
          <input className="mt-1 block w-full border border-gray-300 rounded-md p-2" type="email" id="email" required />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700" htmlFor="message">Message</label>
          <textarea className="mt-1 block w-full border border-gray-300 rounded-md p-2" id="message" rows={4} required></textarea>
        </div>
        <button className="bg-indigo-500 text-white font-semibold py-2 px-4 rounded" type="submit">Send Message</button>
      </form>
    </div>
  );
}